/* eslint-disable react/require-default-props */
import React, { FC } from 'react';
import Icon from '../Icon';

import style from './style.module.scss';

type TProps = {
  colors?: {
    topHexCode: string,
    bodyHexCode: string,
  },
  baseFilterValue?: string;
  locationFilterValue?: string;
};

const CarFilterSelected: FC<TProps> = ({ colors, locationFilterValue, baseFilterValue }: TProps) => {
  return (
    <div id="selected-filters" className={style.selectedFiltersContainer}>
      <div className={style.selectedFilters}>
        {!!colors && (
          <span className="rs-select-color">
            <div
              style={{
                backgroundColor:
                  colors?.topHexCode,
              }}
            />
            <div
              style={{
                backgroundColor:
                  colors?.topHexCode
              }}
            />
          </span>
        )}
        {!!baseFilterValue && (
          <span>{baseFilterValue}</span>
        )}
        {!!locationFilterValue && (
          <span className={style.location}><Icon name="pin" />{locationFilterValue}</span>
        )}
      </div>
    </div>
  );
};

export default CarFilterSelected;
